import address from '../api/search';

import {
  ADDRESS_SEARCH_BEGIN,
  ADDRESS_SEARCH_SUCCESS,
  ADDRESS_SEARCH_FAILURE,
} from './types';

const initialState = {
  error: false,
  errorText: '',
  addressList: {},
};

const getters = {};

const actions = {
  getAddressValue({ commit }, addressValue) {
    commit(ADDRESS_SEARCH_BEGIN);
    return address.getAddressValue(addressValue)
      .then((response) => commit(ADDRESS_SEARCH_SUCCESS, response.data))
      .catch((error) => commit(ADDRESS_SEARCH_FAILURE, error.response.data));
  },
};

const mutations = {
  [ADDRESS_SEARCH_BEGIN](state) {
    state.error = false;
  },
  [ADDRESS_SEARCH_SUCCESS](state, data) {
    state.addressList = data;
    state.error = false;
  },
  [ADDRESS_SEARCH_FAILURE](state, data) {
    state.error = true;
    state.errorText = data;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
